module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/profissao/profissao.component.css
// module id = ./src/app/profissao/profissao.component.css
// module chunks = main